import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { authApi } from '@/api/auth'
import { useAuthStore } from '@/store/auth.store'
import type { LoginPayload } from '@/api/auth'
import type { ApiErrorResponse } from '@/types/api'

export function useLogin() {
  const setAuth = useAuthStore((s) => s.setAuth)

  return useMutation({
    mutationFn: (payload: LoginPayload) => authApi.login(payload),
    onSuccess: ({ data }) => {
      const { access_token, user } = data.data
      setAuth(user, access_token)
    },
  })
}

export function getLoginError(error: unknown): string | null {
  if (axios.isAxiosError(error) && error.response?.data) {
    const errData = error.response.data as ApiErrorResponse
    return errData.errors?.[0]?.message ?? 'Une erreur est survenue.'
  }
  return null
}
